'use client';

import { useEffect, useState } from 'react';

type UseWidgetAdParams = {
  widgetId?: number;
};

export const useWidgetAd = ({ widgetId }: UseWidgetAdParams) => {
  const [adData, setAdData] = useState<{
    uid: string | null;
    image_url: string;
    second_image_url?: string;
    impression_pixel_url?: string;
    link_url: string;
  } | null>(null);

  useEffect(() => {
    const controller = new AbortController();

    fetch(
      `https://${process.env.NEXT_PUBLIC_CACHE_ENDPOINT}/widgets/ad/?widget_id=${widgetId}`,
      {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        signal: controller.signal,
      }
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        const adInfo = data.image as {
          uid: string | null;
          image_url: string;
          second_image_url?: string;
          impression_pixel_url?: string;
          link_url: string;
        };
        setAdData(adInfo);
      })
      .catch((err) => {
        if (!controller.signal.aborted) {
          console.error(
            'Erreur lors de la récupération de la pub du widget:',
            err
          );
        }
      });

    return () => controller.abort();
  }, [widgetId]);

  return { adData };
};
